import { render, staticRenderFns } from "./UpdateSpartPart.vue?vue&type=template&id=4cf5d822&scoped=true&"
import script from "./UpdateSpartPart.vue?vue&type=script&lang=js&"
export * from "./UpdateSpartPart.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSpartPart.vue?vue&type=style&index=0&id=4cf5d822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf5d822",
  null
  
)

export default component.exports